import { planKeys } from 'config/planKeys';

/**
 * - 0: 後台抽獎
 * - 1: 參加獎
 * - 3: 刮刮卡
 * - 4: 大輪盤
 * - 5: 戳戳樂
 * - 6: 紅包雨
 * - 7: 拉霸
 * - 8: 好禮自由選
 * - 9: 點數兌獎
 */
export const ADMIN = 0;
export const JOIN_AND_GET = 1;
export const SCRATCH_CARD = 3;
export const WIN_WHEEL = 4;
export const POKE_GAME = 5;
export const RED_ENVELOPE_RAIN = 6;
export const SLOTS = 7;
export const PICK_THE_PRIZE = 8;
export const POINTS_REDEEM = 9;

// 泛用的直接 開獎品路徑
export const lotteryGeneralAnimationType = Symbol('lotteryGeneralType');
export const lotteryOpenPathParams = {
    GENERAL: 'general',
    WIN_WHEEL: 'winwheel',
    SCRATCH_CARD: 'scratchcard',
    POKE_GAME: 'pokeGame',
    RED_ENVELOPE_RAIN: 'redEnvelopeRain',
    SLOTS: 'slots',
    PICK_THE_PRIZE: 'pickThePrize',
    POINTS_REDEEM: 'pointsRedeem'
};

export const lotteriesConfig = {
    instant: {
        JOIN_AND_GET: {
            type: JOIN_AND_GET,
            planKey: planKeys.lotteries.JOIN_AND_GET,
            lotteryAnimatePath: lotteryOpenPathParams.GENERAL
        }
    },
    participant: {
        SCRATCH_CARD: {
            type: SCRATCH_CARD,
            planKey: planKeys.lotteries.SCRATCH_CARD,
            lotteryAnimatePath: lotteryOpenPathParams.SCRATCH_CARD
        },
        WIN_WHEEL: {
            type: WIN_WHEEL,
            planKey: planKeys.lotteries.WIN_WHEEL,
            lotteryAnimatePath: lotteryOpenPathParams.WIN_WHEEL
        },
        POKE_GAME: {
            type: POKE_GAME,
            planKey: planKeys.lotteries.POKE_GAME,
            lotteryAnimatePath: lotteryOpenPathParams.POKE_GAME
        },
        RED_ENVELOPE_RAIN: {
            type: RED_ENVELOPE_RAIN,
            planKey: planKeys.lotteries.RED_ENVELOPE_RAIN,
            lotteryAnimatePath: lotteryOpenPathParams.RED_ENVELOPE_RAIN
        },
        SLOTS: {
            type: SLOTS,
            planKey: planKeys.lotteries.SLOTS,
            lotteryAnimatePath: lotteryOpenPathParams.SLOTS
        },
        PICK_THE_PRIZE: {
            type: PICK_THE_PRIZE,
            planKey: planKeys.lotteries.PICK_THE_PRIZE,
            lotteryAnimatePath: lotteryOpenPathParams.PICK_THE_PRIZE
        },
        POINTS_REDEEM: {
            type: POINTS_REDEEM,
            planKey: planKeys.lotteries.POINTS_REDEEM,
            lotteryAnimatePath: lotteryOpenPathParams.POINTS_REDEEM
        }
    },
    admin: {
        ADMIN: {
            type: ADMIN,
            planKey: planKeys.lotteries.ADMIN,
            lotteryAnimatePath: lotteryOpenPathParams.GENERAL
        }
    }
};

// 給獎動畫對應路徑
export const lotteryAnimationPathMapping = Object.entries({
    ...lotteriesConfig.instant,
    ...lotteriesConfig.participant,
    ...lotteriesConfig.admin
}).reduce(
    (obj, [, { type, lotteryAnimatePath }]) => {
        obj[type] = lotteryAnimatePath;
        return obj;
    },
    {
        [lotteryGeneralAnimationType]: lotteryOpenPathParams.GENERAL
    }
);
export const lotteryInstantTypes = Object.entries(lotteriesConfig.instant).reduce(
    (obj, [key, { type }]) => {
        obj[key] = type;
        return obj;
    },
    {}
);
export const lotteryParticipantTypes = Object.entries(lotteriesConfig.participant).reduce(
    (obj, [key, { type }]) => {
        obj[key] = type;
        return obj;
    },
    {}
);
export const lotteryAdminTypes = Object.entries(lotteriesConfig.admin).reduce(
    (obj, [key, { type }]) => {
        obj[key] = type;
        return obj;
    },
    {}
);

const lotteriesHaveAnimation = new Set([
    WIN_WHEEL,
    SCRATCH_CARD,
    POKE_GAME,
    RED_ENVELOPE_RAIN,
    SLOTS,
    PICK_THE_PRIZE
]);
export function isLotteryHasAnimation(type) {
    return lotteriesHaveAnimation.has(type);
}

const hideThankPrizeLottery = new Set([ADMIN, PICK_THE_PRIZE]);
export function getHideThankPrizeLottery(type) {
    return hideThankPrizeLottery.has(type);
}

/**
 * 獎品分配規則算法
 *
 * - 0: 機率
 * - 1: 順序
 * - 2: 沒限制，自由選
 * - 3: 全部選
 * - 4: 隨機選一個
 */
export const lotteryAlgorithmTypes = {
    PERCENT: 0,
    ORDER: 1,
    SELF_PICK: 2,
    ALL_PICK: 3,
    RANDOM_ONE: 4
};

export const getLotteryAlgorithmTypeWhenOpenPrizeTaskFilter = lotteryType => {
    switch (lotteryType) {
        case JOIN_AND_GET:
            return lotteryAlgorithmTypes.ALL_PICK;
        case SCRATCH_CARD:
        case WIN_WHEEL:
        case POKE_GAME:
        case RED_ENVELOPE_RAIN:
        case SLOTS:
            return lotteryAlgorithmTypes.RANDOM_ONE;
        case PICK_THE_PRIZE:
        case POINTS_REDEEM:
            return lotteryAlgorithmTypes.SELF_PICK;
        default:
            return lotteryAlgorithmTypes.ALL_PICK;
    }
};

export const getLotteryAlgorithmTypeWhenClosePrizeTaskFilter = lotteryType => {
    switch (lotteryType) {
        case JOIN_AND_GET:
        case SCRATCH_CARD:
        case WIN_WHEEL:
        case POKE_GAME:
        case RED_ENVELOPE_RAIN:
        case SLOTS:
            return lotteryAlgorithmTypes.PERCENT;
        case PICK_THE_PRIZE:
        case POINTS_REDEEM:
            return lotteryAlgorithmTypes.SELF_PICK;
        default:
            return lotteryAlgorithmTypes.PERCENT;
    }
};

/**
 * 獎品數量顯示
 *
 * - 0: 不顯示
 * - 1: 顯示獎品總數
 * - 2: 顯示獎品剩餘數量總數
 */
const NOT_SHOW = 0;
const SHOW_REMAIN_AMOUNT = 1;
const SHOW_TOTAL_AMOUNT = 2;
export const lotteryRestShowTypes = {
    NOT_SHOW,
    SHOW_REMAIN_AMOUNT,
    SHOW_TOTAL_AMOUNT
};

/**
 * 獎品發完處理方式
 *
 * - 1: 自動暫停活動
 * - 0: 繼續進行活動
 */
const CONTINUE = 0;
const SUSPEND = 1;
export const lotteryWhenNoPrizeTypes = {
    SUSPEND,
    CONTINUE
};

/**
 * 獎品領取限制
 *
 * - -1: 無限制
 * - 1: 限制領取上限 (最多一個)
 */
const UNLIMITED = -1;
const LIMITED = 1;
export const lotteryPrizeGetLimitTypes = {
    UNLIMITED,
    LIMITED
};
